export default {
  accessToken (state, getters, rootState) {
    return state.accessToken
  },
  basicToken (state, getters, rootState) {
    return btoa(state.clientId + ':' + state.clientSecret)
  }
}



// WEBPACK FOOTER //
// ./src/modules/authorization/store/getters.js